'use strict';

import angular from 'angular';

function MemTransResource($resource) {
  // eslint-disable-next-line
  return $resource('/api/groups/:groupId/members/:personId/transactions/:id/:controller', {
    groupId: '@groupId', personId: '@personId', id: '@id'
  }, {
    create: {
      method: 'POST'
    },
    invoiceDues: {
      method: 'POST',
      params: {controller: 'invoicedues'},
      isArray: true
    },
    update: { method: 'PUT' }
  });
}

MemTransResource.$inject = ['$resource'];

export default angular.module('georgeApp.memTxnSvc', [])
  .factory('MemTxnSvc', MemTransResource)
  .name;
